import axios from 'axios'
import log from 'salvo-lite/log'
class LoadMore {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._elem = elem
        this._container = document.querySelector('.account__orders')
        this._nextPage = elem.getAttribute('data-load-more')
        this._progressBar = document.querySelector('[data-progress]')
        this._progressText = document.querySelector('[data-progress-text]')
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._progress()
        this._elem.addEventListener('click', e => {
            axios.get(this._nextPage).then((response) => {
                this._elem.classList.add('visually-hidden')
                this._build(response)
            })
        })
    }
    _build (response) {
        const content = document.createElement('div')
        content.innerHTML = response.data
        const orders = content.querySelector('.account__orders')
        const newOrders = orders.innerHTML
        document.querySelector('[data-progress]').remove()
        document.querySelector('[data-progress-text]').remove()
        const existingHTML = this._container.innerHTML
        const newHTML = existingHTML + newOrders
        this._container.innerHTML = newHTML
        this._theme.registerComponents(this._container)
    }
    _progress () {
        const ordersShowing = document.querySelectorAll('.account__order').length
        const total = parseInt(this._progressBar.getAttribute('data-progress'))
        const percent = (ordersShowing / total) * 100
        this._progressText.querySelector('span').textContent = ordersShowing
        this._progressBar.querySelector('span').style.width = percent + '%'
    }
}

export default LoadMore



// WEBPACK FOOTER //
// ./src/resources/scripts/components/LoadMore.js